"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const immutableMapRecord_1 = __importDefault(require("./immutableMapRecord"));
const cleanUndefinedFromValue = (value) => {
    if ((0, valueIsUndefined_1.default)(value)) {
        return null;
    }
    if ((0, valueIsArray_1.default)(value)) {
        return value.map(cleanUndefinedFromValue);
    }
    if ((0, valueIsRecord_1.default)(value)) {
        const cleaned = (0, immutableMapRecord_1.default)(value, (key, item) => cleanUndefinedFromValue(item));
        return Object.entries(cleaned).reduce((accum, [key, item]) => {
            if ((0, valueIsNullOrUndef_1.default)(item)) {
                return accum;
            }
            return Object.assign(Object.assign({}, accum), { [key]: item });
        }, {});
    }
    return value;
};
exports.default = cleanUndefinedFromValue;
